var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-yellow"},[_c('i',{staticClass:"fas fa-bell-exclamation icon"}),_c('p',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.$store.state.actionMessage.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }